export default "__VITE_ASSET__088d0a9e__"